import { render } from "./PostCommentaryPage.vue?vue&type=template&id=4dc4c0ce&ts=true"
import script from "./PostCommentaryPage.vue?vue&type=script&lang=ts"
export * from "./PostCommentaryPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__